import { createPermission } from '@backstage/plugin-permission-common';

export const batchEditorUsePermission = createPermission({
  name: 'batch-editor.use',
  attributes: { action: 'read' },
});

export const batchEditorExecutePermission = createPermission({
  name: 'batch-editor.execute',
  attributes: { action: 'create' },
});
